import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const FuelCardListToggleContext = createContext(null);

export function FuelCardListToggleProvider({ children }) {
    const [pendingCardId, setPendingCardId] = useState(null);

    const beginToggle = useCallback((cardId) => {
        setPendingCardId(cardId);
    }, []);

    const endToggle = useCallback(() => {
        setPendingCardId(null);
    }, []);

    const value = useMemo(
        () => ({
            pendingCardId,
            beginToggle,
            endToggle,
            isGloballyDisabled: pendingCardId != null,
        }),
        [pendingCardId, beginToggle, endToggle],
    );

    return (
        <FuelCardListToggleContext.Provider value={value}>{children}</FuelCardListToggleContext.Provider>
    );
}

export function useFuelCardListToggle() {
    return useContext(FuelCardListToggleContext);
}
